import { useAuth0 } from '@auth0/auth0-react'
import { LearningManagement_V1 } from '@rw1/auto-generated-clients'
import { useAppConfig, useEnvConfig } from 'rwo-react'
import { setAccessTokenProvider } from './accessTokenProvider'
import { joinUrl } from '.'

let learningManagementClientV1:
  | LearningManagement_V1.LearningManagementClientV1
  | undefined

export const useLearningManagementServiceV1 =
  (): LearningManagement_V1.LearningManagementClientV1 => {
    const { getAccessTokenSilently } = useAuth0()
    const { backendAddress } = useEnvConfig()
    const { config } = useAppConfig()

    learningManagementClientV1 ??=
      new LearningManagement_V1.LearningManagementClientV1(
        joinUrl(backendAddress, config['LMSApiSuffix']),
      )
    setAccessTokenProvider(learningManagementClientV1, getAccessTokenSilently)

    return learningManagementClientV1
  }
